<template>
	<div
		class="flex size-full cursor-pointer flex-col items-center justify-center bg-black px-8 text-center md:bg-[#1f1f1f] md:px-10"
		data-testid="shorts-unavailable-entry"
	>
		<div
			class="mx-auto flex max-w-[320px] flex-col items-center gap-8 md:gap-7"
		>
			<div class="space-y-3 md:space-y-4">
				<h2
					class="text-[17px] font-medium leading-[1.35] text-white md:font-matter-sq md:text-[20px] md:font-normal md:text-white"
				>
					Este vídeo não está mais disponível
				</h2>

				<p
					class="text-[15px] leading-[1.45] text-white/72 md:font-sans md:text-[16px] md:font-normal md:leading-[1.5] md:text-white-dark-4"
				>
					<span class="md:hidden">
						Deslize verticalmente para ver outros Shorts semelhantes a este
					</span>
					<span class="hidden md:inline">
						Faça scroll para ver outros Shorts semelhantes a este
					</span>
				</p>
			</div>

			<div class="flex items-center justify-center">
				<img
					src="/icons/icon-swipe-vertical.svg"
					alt=""
					aria-hidden="true"
					width="48"
					height="48"
					class="size-12 md:hidden"
				/>

				<img
					src="/icons/icon-scroll-vertical.svg"
					alt=""
					aria-hidden="true"
					width="48"
					height="48"
					class="hidden size-12 md:block"
				/>
			</div>
		</div>
	</div>
</template>
